export const maskTime = value => {
	if ( value ) {
		// remove all non-digits and split string into an array
		const arr = value.toString()
			.replace( /[^0-9]/g, '' )
			.split( '' );

		const maskedArr = arr.map( ( char, i, array ) => {
			switch ( i ) {
				case 0:
					return Number( char ) > 1
						? `0${ char }`
						: char;
				case 1:
					return Number( array[ i - 1 ] ) === 1
						? Number( char ) < 3
							? char
							: '2'
						: char;
				case 2:
					return Number( char ) > 5
						? `:0${ char }`
						: `:${ char }`;

				default:
					return char;
			}
		} );

		// join array into a string
		return maskedArr.join( '' );
	}

	return '';
};

export const unmaskTime = value => {
	return value;
};

export const formatTimeString = ( value, amOrPm ) => {
	if ( value ) {
		// remove all non-digits (or colons) and split string into an array
		const str = value.toString()
			.replace( /[^0-9:]/g, '' );

		let updatedValue = str;

		switch ( str.length ) {
			case 1:
				updatedValue = `0${ str }:00`;
				break;
			case 2:
				updatedValue = `${ str }:00`;
				break;
			case 3:
				updatedValue = `${ str }00`;
				break;
			case 4:
				updatedValue = `${ str }0`;
				break;
			default:
				break;
		}

		return `${ updatedValue }${ amOrPm ? ` ${ amOrPm }` : '' }`;
	}

	return '0:00';
};
